import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';

const state = {
    ventaId: 0,
    cae: '',
    numero: 0,
    validado: Boolean(false),
    msjValidacion: '',
    datosValidacion: [],
    errores: [],
    observaciones: [],

    afipComprobanteTipoCV: 0,
    numeroPuntoVentaCV: 0,
    numeroCV: 0,
    datosComprobanteValidado: [],

    afipComprobanteTipoUC: { id: 1, nombre: 'FACTURA A' },
    afipComprobanteTipoNombreUC: 'FACTURA A',
    numeroPuntoVentaUC: 0,
    numeroUC: 0,
    datosUltimoComprobante: [],

    afipComprobantesTipos: [
        { id: 1, nombre: 'FACTURA A' },
        { id: 3, nombre: 'NOTA DE CREDITO A' },
        { id: 2, nombre: 'NOTA DE DEBITO A' },
        { id: 6, nombre: 'FACTURA B' },
        { id: 8, nombre: 'NOTA DE CREDITO B' },
        { id: 7, nombre: 'NOTA DE DEBITO B' },
        { id: 201, nombre: 'FACTURA DE CREDITO ELECTR. A' },
        { id: 203, nombre: 'NOTA DE CREDITO ELECTR. A' },
        { id: 202, nombre: 'NOTA DE DEBITO ELECTR. A' },
        { id: 206, nombre: 'FACTURA DE CREDITO ELECTR. B' },
        { id: 208, nombre: 'NOTA DE CREDITO ELECTR. B' },
        { id: 207, nombre: 'NOTA DE DEBITO ELECTR. B' },
        { id: 19, nombre: 'FACTURA DE EXPORTACION' },
        { id: 20, nombre: 'NOTA DE CREDITO DE EXPORTACION' },
        { id: 21, nombre: 'NOTA DE DEBITO DE EXPORTACION' },
    ],
    
    afipComprobantesTiposList: [
        'FACTURA A',
        'NOTA DE CREDITO A',
        'NOTA DE DEBITO A',
        'FACTURA B',
        'NOTA DE CREDITO B',
        'NOTA DE DEBITO B',
        'FACTURA DE CREDITO ELECTR. A',
        'NOTA DE CREDITO ELECTR. A',
        'NOTA DE DEBITO ELECTR. A',
        'FACTURA DE CREDITO ELECTR. B',
        'NOTA DE CREDITO ELECTR. B',
        'NOTA DE DEBITO ELECTR. B',
        'FACTURA DE EXPORTACION',
        'NOTA DE CREDITO DE EXPORTACION',
        'NOTA DE DEBITO DE EXPORTACION'
    ]

};

const mutations = {
    updateField,

    'INICIALIZAR_CONSULTA_COMPROBANTE' (state, params) {
        state.afipComprobanteTipoCV = params.afipComprobanteTipo;
        state.numeroPuntoVentaCV = params.numeroPuntoVenta;
        state.numeroCV = params.numero;
        state.datosComprobanteValidado = [];
    },
    'SET_CONSULTA_COMPROBANTE'(state, params) {
        state.datosComprobanteValidado = params.datosComprobanteValidado;
    },

    'INICIALIZAR_CONSULTA_ULTIMO_AUTORIZADO' (state) {
        state.datosUltimoComprobante = [];
        state.numeroUC = 0;
    },
    'SET_CONSULTA_ULTIMO_AUTORIZADO'(state, params) {
        state.datosUltimoComprobante = params.datosUltimoComprobante;
        state.numeroUC = params.datosUltimoComprobante? params.datosUltimoComprobante.numero : 0;
    },
    'SET_AFIP_COMPROBANTE_TIPO_UC'(state, afipComprobanteTipo) {
        state.afipComprobanteTipoUC = afipComprobanteTipo;
        state.afipComprobanteTipoNombreUC= afipComprobanteTipo? afipComprobanteTipo.nombre.trim() : null;
    },

    'INICIALIZAR_VALIDACION' (state, params) {
        state.ventaId = params.ventaId;
        state.cae = '';
        state.numero = 0;
        state.validado = Boolean(false),
        state.msjValidacion = '';
        state.datosValidacion = [];
        state.errores = [];
        state.observaciones = [];
    },
    'SET_VALIDACION'(state, params) {
        state.datosValidacion = params.datosValidacion;
        state.cae = params.datosValidacion.cae;
        state.numero = params.datosValidacion.numero;
        state.errores = params.datosValidacion.errores;
        state.observaciones = params.datosValidacion.observaciones;

        state.validado = params.datosValidacion.cae.trim() != '' ? Boolean(true) : Boolean(false);
        state.msjValidacion = '';
        if (state.observaciones) {
            state.observaciones.forEach(observacion => {
                state.msjValidacion += '\n' + observacion.descripcion;  
            });
        }
        if (state.errores) {
            state.errores.forEach(error => {
                state.msjValidacion += '\n' + error.descripcion;  
            }); 
        }
    },
};


const getters = {
    getField,

    validado (state) {
        return state.validado;
    },
    msjValidacion (state) {
        return state.msjValidacion;
    },
    datosValidacion (state) {
        return state.datosValidacion;
    },
    datosComprobanteValidado (state) {
        return state.datosComprobanteValidado;
    },
    datosUltimoComprobante (state) {
        return state.datosUltimoComprobante;
    },
    afipComprobantesTipos (state) {
        return state.afipComprobantesTipos;
    },
    afipComprobantesTiposList (state) {
        return state.afipComprobantesTiposList;
    },
};

const actions = {
    getUltimoAutorizado: ({ commit }) => {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_CONSULTA_ULTIMO_AUTORIZADO');
            
            let queryString = '?numeroPuntoVenta=' + state.numeroPuntoVentaUC
                + '&comprobanteTipoAfip=' + state.afipComprobanteTipoUC.id

            apiAxios.get('facturaelectronica/ultimo' + queryString) 
                .then(res => {
                    let params = {
                        datosUltimoComprobante: res.data
                    }
                    commit('SET_CONSULTA_ULTIMO_AUTORIZADO', params);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    setAfipComprobanteTipoUC: ({commit}, afipComprobanteTipo) => {
        commit('SET_AFIP_COMPROBANTE_TIPO_UC', afipComprobanteTipo);
    },

    getDatosComprobanteValidado: ({ commit }, params) => {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_CONSULTA_COMPROBANTE', params);
            
            let queryString = '?numeroPuntoVenta=' + params.numeroPuntoVenta
                + '&comprobanteTipoAfip=' + params.comprobanteTipoAfip
                + '&numero=' + params.numero;

            apiAxios.get('facturaelectronica/comprobante' + queryString) 
                .then(res => {
                    let params = {
                        datosComprobanteValidado: res.data
                    }
                    commit('SET_CONSULTA_COMPROBANTE', params);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    validarComprobante: ({ commit }, params) => {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_VALIDACION', params);
            
            let queryString = '?venta=' + params.ventaId;

            apiAxios.get('facturaelectronica/validar' + queryString) 
                .then(res => {
                    let params = {
                        datosValidacion: res.data
                    }
                    commit('SET_VALIDACION', params);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    actualizarDatosValidacion: ({ commit }, params) => {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_VALIDACION', params);
            
            let queryString = '?venta=' + params.ventaId;

            apiAxios.get('facturaelectronica/actualizar-validacion' + queryString) 
                .then(res => {
                    let params = {
                        datosValidacion: res.data
                    }
                    commit('SET_VALIDACION', params);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}